import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoQualityInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { VideoQualityEnum } from '../../../types/enums/VideoQualityEnum';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VideoQualityInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in VideoQualityEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key.split(/(?=[A-Z])/).join(' ')}`,
        value: `${VideoQualityEnum[key as keyof typeof VideoQualityEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoQuality: parseInt(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoQuality: parseInt(option.value),
        });
      }
    }
  };

  return (
    <div className="video-quality-input">
      <div className="input-title">
        {t('producer.inputs.video-quality.title')}
        <Help
          title="Video Quality"
          text="<b>Bitrate Control:</b> Adjusts the video output based on a target bitrate. This helps maintain a consistent data rate, which is useful for streaming to networks with limited bandwidth.<br/><br/><b>Constant Quality:</b> Maintains a consistent visual quality across the video. The bitrate may vary to keep the quality uniform, which ensures clearer images during complex scenes.<br/><br/><b>Fixed Quantizer:</b> Uses a fixed compression level for the video. This can result in smaller file sizes but may affect quality in more detailed or dynamic scenes.<br/><br/>Choose the option that best balances video quality and file size for your stream."
        />
      </div>
      <Dropdown
        value={project.encoder.transcoderVideoQuality.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.video-quality.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.video-quality.footer')}</div>
    </div>
  );
};

export default React.memo(VideoQualityInput);
